import { IRootState } from 'app/shared/reducers';
import { Console } from 'console';
import { createSelector, Selector } from 'reselect';
import { CmsState } from './state';

const selectCmsState: any = (state: IRootState) => state.cms;

export const getDocument = (docType: string) =>
  createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => cms.documents[docType]);

export const isReady = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => cms.isReady);

export const getAvatarList = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataInfoCms = cms.documents['avatar_information']?.data;
  const list = dataInfoCms?.items?.map(i => {
    return { code: i?.code, name: i?.name, image: i?.icon?.url };
  });
  return list;
});

export const getHomeInfoSelector = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataInfoCms = cms.documents['generic_mobile_home_customer']?.data || cms.documents['generic_mobile_home_customer_v2']?.data;
  return {
    avatarText: dataInfoCms?.avatar_text || '',
    avatarTextEmptyList: dataInfoCms?.avatar_text_empty_list || '',
    contractItem: {
      btnDeclareSinisterLabel: dataInfoCms?.btn_declare_claim || '',
      btnFollowClaimsLabel: dataInfoCms?.btn_sellect_claim || '',
      btnManageSubscriptionLabel: dataInfoCms?.btn_manage_subscription_label || '',
      subscriptionLabel: dataInfoCms?.subscription_label || '',
      dateLabel: dataInfoCms?.subscription_date_label || '',
      icon: dataInfoCms?.insured_good_icon?.url || '',
    },
    claimItem: {
      claim_number_label: dataInfoCms?.claim_number_label || '',
      claim_declare_date_label: dataInfoCms?.claim_declare_date_label || '',
    },
    modal: {
      modal_msg_dont_declare_claim: dataInfoCms?.modal_msg_dont_declare_claim || '',
      modal_btn_label: dataInfoCms?.modal_btn_label || '',
    },
    bntStillSubscriptionLabel: dataInfoCms?.btn_still_subscription_label || '',
    bntStillSubscriptionLabelLink: dataInfoCms?.btn_still_subscription_label_link || '',
    bntStillSubscriptionLabelActionLink: dataInfoCms?.btn_still_subscription_label_action_link || '',
    btnSearchSubscriptionLabel: dataInfoCms?.btn_search_subscription_label || '',
  };
});

export const getResindSelector = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const resindCms = cms.documents['contract_cancellation_engine']?.data;

  return {
    avatar_text: resindCms?.avatar_text,
    back_button: resindCms?.back_button,
    back_button_resind: resindCms?.back_button_resind,
    confirm_button: resindCms?.confirm_button,
    confirmation_text: resindCms?.confirmation_text,
    contact_form: {
      modal_textarea_error: resindCms?.modal_textarea_error,
      textarea_placeholder: resindCms?.textarea_placeholder,
      resind_checkbox: resindCms?.resind_checkbox,
    },
    resind_contact_choice: {
      phone_choice: resindCms?.resind_contract_choice?.find(x => x.key === 'phone_choice'),
      contact_choice: resindCms?.resind_contract_choice?.find(x => x.key === 'contact_choice'),
    },
    phone_contact_text: resindCms?.phone_contact_text,
    phone_contact: resindCms?.phone_contact,
    avatar_text_phone_mode: resindCms?.avatar_text_phone_mode,
  };
});

export const getContractEngineSelector = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataInfoCms = cms.documents['mobile_contract_engine_v2']?.data;

  return {
    avatar_text: dataInfoCms?.avatar_text,
    components: dataInfoCms?.component_items,
    contract_recap: {
      link_cancel_insurance_label: dataInfoCms?.link_cancel_insurance_label,
      sku_liste: dataInfoCms?.sku_liste,
      subscription_number: dataInfoCms?.component_recap_items?.find(x => x.key === 'subscription_number'),
      show_insured: dataInfoCms?.component_recap_items?.find(x => x.key === 'SHOW_INSURED'),
      user_full_name: dataInfoCms?.component_recap_items?.find(x => x.key === 'user_full_name'),
      subscription_status: dataInfoCms?.component_recap_items?.find(x => x.key === 'subscription_status'),
      brand: dataInfoCms?.component_recap_items?.find(x => x.key === 'brand'),
      begin_cover_date: dataInfoCms?.component_recap_items?.find(x => x.key === 'begin_cover_date'),
      IMEI: dataInfoCms?.component_recap_items?.find(x => x.key === 'IMEI'),
      subscription_purchasedate: dataInfoCms?.component_recap_items?.find(x => x.key === 'subscription_purchasedate'),
      unpaid_label: dataInfoCms?.unpaid_label,
      link_to_regularize_my_contributions: dataInfoCms?.link_to_regularize_my_contributions,
      my_guarantees_label: dataInfoCms?.my_guarantees_label,
      broken_label: dataInfoCms?.broken_label,
      loss_label: dataInfoCms?.loss_label,
      flight_label: dataInfoCms?.flight_label,
      claim_number_label: dataInfoCms?.claim_number_label,
      claim_declare_date_label: dataInfoCms?.claim_declare_date_label,
      btn_follow_claims_label: dataInfoCms?.btn_follow_claims_label,
      btn_follow_claim_label: dataInfoCms?.btn_follow_claim_label,
      btn_declare_claim_label: dataInfoCms?.btn_declare_claim_label,
      modal_claim_eligibility: dataInfoCms?.modal_claim_eligibility,
      modal_btn_label: dataInfoCms?.btn_cancel_label,
      button_cotisation: dataInfoCms?.button_cotisation,
    },
    component_recap_contractual: {
      contractual_title: dataInfoCms?.contractual_title,
      contractual_icon: dataInfoCms?.contractual_icon,
      contractual_color: dataInfoCms?.contractual_color,
    },
    contract_personnels_infos: {
      component_items_infos_perso: dataInfoCms?.component_items_infos_perso,
      first_name_label: dataInfoCms?.first_name_label,
      name_label: dataInfoCms?.name_label,
      display_mobile_label: dataInfoCms?.display_mobile_label,
      display_fix_phone_label: dataInfoCms?.display_fix_phone_label,
      display_email_label: dataInfoCms?.display_email_label,
      display_contact_info_label: dataInfoCms?.display_contact_info_label,
      display_address_label: dataInfoCms?.display_address_label,
      contact_icon: dataInfoCms?.contact_icon?.url,
      btn_cancel_label1: dataInfoCms?.btn_cancel_label1,
      address_icon: dataInfoCms?.addres_icon?.url,
      modal_error_msg: dataInfoCms?.modal_error_msg,
      modal_succses_msg: dataInfoCms?.modal_succses_msg,
      street_number_label: dataInfoCms?.street_number_label,
      adress_label: dataInfoCms?.adress_label,
      additional_address_label: dataInfoCms?.additional_address_label,
      town_label: dataInfoCms?.town_label,
      phone_number_label: dataInfoCms?.phone_number_label,
      postal_code_label: dataInfoCms?.postal_code_label,
      email_label: dataInfoCms?.email_label,
      btn_cancel_label: dataInfoCms?.btn_cancel_label,
      btn_confirm_label: dataInfoCms?.btn_confirm_label,
      message_inscrit: dataInfoCms?.message_inscrit,
      message_inscrit_2: dataInfoCms?.message_inscrit_2,
      sku_liste: dataInfoCms?.sku_liste,
      edit_icon: dataInfoCms?.edit_icon?.url,
      personal_info_modal_error: dataInfoCms?.personal_info_modal_error,
      input_list: {
        street: dataInfoCms?.input_list?.find(x => x.key === 'street'),
        streetNumber: dataInfoCms?.input_list?.find(x => x.key === 'streetNumber'),
        additionalAddress: dataInfoCms?.input_list?.find(x => x.key === 'additionalAddress'),
        city: dataInfoCms?.input_list?.find(x => x.key === 'city'),
        codePostal: dataInfoCms?.input_list?.find(x => x.key === 'codePostal'),
        email: dataInfoCms?.input_list?.find(x => x.key === 'email'),
        mobile: dataInfoCms?.input_list?.find(x => x.key === 'mobile'),
      },
    },
    contract_info_bancaire: {
      titulaire_compte_label: dataInfoCms?.titulaire_compte_label,
      iban_label: dataInfoCms?.iban_label,
      bic_label: dataInfoCms?.bic_label,
      btn_annuler_label: dataInfoCms?.btn_annuler_label,
      btn_confirmer_label: dataInfoCms?.btn_confirmer_label,
      edit_icon: dataInfoCms?.edit_icon?.url,
      iban_error_msg: dataInfoCms?.iban_error_msg,
      info_bank_modal_error: dataInfoCms?.info_bank_modal_error,
    },
    cotisation_tab: {
      cotisation_quantity_text_singular: dataInfoCms?.cotisation_quantity_text_singular,
      cotisation_quantity_text_plural: dataInfoCms?.cotisation_quantity_text_plural,
      cotisation_amount_icon: dataInfoCms?.cotisation_amount_icon?.url,
      cotisation_amount: dataInfoCms?.cotisation_amount,
      cotisation_date_icon: dataInfoCms?.cotisation_date_icon?.url,
      cotisation_date: dataInfoCms?.cotisation_date,
      cotisation_warning: dataInfoCms?.cotisation_warning,
      cotisation_warning_plural: dataInfoCms?.cotisation_warning_plural,
      cotisation_success_icon: dataInfoCms?.cotisation_success_icon?.url,
      cotisation_success: dataInfoCms?.cotisation_success,
      cotisation_resubmitted_singular: dataInfoCms?.cotisation_resubmitted_singular,
      cotisation_resubmitted_plural: dataInfoCms?.cotisation_resubmitted_plural,
      cotisation_updated: dataInfoCms?.cotisation_updated,
      cotisation_to_pay_label: dataInfoCms?.cotisation_to_pay_label,
      cotisation_total_label: dataInfoCms?.cotisation_total_label,
      cotisation_taxes_label: dataInfoCms?.cotisation_taxes_label,
      cotisation_payement_success: dataInfoCms?.cotisation_payement_success,
      btn_annuler_label: dataInfoCms?.m_btn_annuler_label,
      btn_confirmer_label: dataInfoCms?.m_btn_confirmer_label,
      multi_cotisation_to_pay_label: dataInfoCms?.multi_cotisation_to_pay_label,
      status_paybox: dataInfoCms?.status_paybox,
    },
    sku_liste: dataInfoCms?.sku_liste,
  };
});
export const getClaimListSelector = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataInfoCms = cms.documents['generic_mobile_claim_list_customer']?.data;

  return {
    claimListeItems: {
      claimNumberLabel: dataInfoCms?.claim_liste_items[0]?.claim_number_label || '',
      dateDeclarationLabel: dataInfoCms?.claim_liste_items[0]?.declartion_date_label || '',
      icon: dataInfoCms?.claim_liste_items[0]?.smartphone_icon?.url || '',
    },
  };
});

export const getClaimEngineSelector = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataInfoCms = cms.documents['mobile_claim_engine_v2']?.data;
  return {
    avatar_text: dataInfoCms?.avatar_text,
    components_item: dataInfoCms?.component_item,
    claim_recap_items: {
      items_recap: dataInfoCms?.items,
      claim_number_label: dataInfoCms?.claim_number_label,
      serial_number_label: dataInfoCms?.serial_number_label,
      declaration_date_label: dataInfoCms?.declaration_date_label,
      claim_type_label: dataInfoCms?.claim_type_label,
      claim_event_link_label: dataInfoCms?.claim_event_link_label,
      button_check_geolocation_label: dataInfoCms?.button_check_geolocation_label,
      button_download_voucher_label: dataInfoCms?.button_download_voucher_label,
      property_concerned_label: dataInfoCms?.property_concerned_label,
      btn_complet_claim: dataInfoCms?.btn_complet_claim,
      imei_label: dataInfoCms?.imei_label,
      description_label: dataInfoCms?.description_label,
      description_show_more_label: dataInfoCms?.description_show_more_label,
      description_show_less_label: dataInfoCms?.description_show_less_label,
      modal_generate_bp_error: dataInfoCms?.modal_generate_bp_error,
      modal_geolocation_check_info: dataInfoCms?.modal_geolocation_check_info,
      modal_degeolocalisation_error_confirm_button: dataInfoCms?.modal_degeolocalisation_error_confirm_button,
      modal_degeolocalisation_error_contact_button: dataInfoCms?.modal_degeolocalisation_error_contact_button,
      max_attempts_reached_message: dataInfoCms?.max_attempts_reached_message,
      attempts_messages: dataInfoCms?.attempts_messages,
      unknown_attempt_message: dataInfoCms?.unknown_attempt_message,
      error_attempt_message: dataInfoCms?.error_attempt_message,
    },

    claim_event_items: {
      wait_icon: dataInfoCms?.current_event_icon?.url,
      finish_icon: dataInfoCms?.event_finish_icon?.url,
      rejected_claim_label: dataInfoCms?.rejected_claim_label,
      motif_label: dataInfoCms?.motif_label,
      print_my_travel_voucher: dataInfoCms?.print_my_travel_voucher,
    },
    email_icon: dataInfoCms?.email_icon,
    phone_icon: dataInfoCms?.phone_icon,
    claim_document_items: {
      docuemtns_status_list: dataInfoCms?.docuemtns_status_list,
      document_number: dataInfoCms?.document_number,
      download_certificate_icon: dataInfoCms?.download_certificate_icon,
      download_certificate_text: dataInfoCms?.download_certificate_text,
      clean_documents: dataInfoCms?.clean_documents,
      documents_formats_upload_informations: dataInfoCms?.documents_formats_upload_informations,
      documents_size_upload_informations: dataInfoCms?.documents_size_upload_informations,
      documents_upload_informations: dataInfoCms?.documents_upload_informations,
      send_document_text: dataInfoCms?.send_document_text,
      send_label: dataInfoCms?.send_label,
      not_conforme_info_label: dataInfoCms?.not_conforme_info_label,
      modal_error: {
        modal_error_documents_formats: dataInfoCms?.modal_error_documents_formats,
        modal_error_documents_size: dataInfoCms?.modal_error_documents_size,
        modal_error_max_uploaded_documents: dataInfoCms?.modal_error_max_uploaded_documents,
      },
      claim_document_items_icon: {
        done_icon: dataInfoCms?.done_icon,
        priority_high_icon: dataInfoCms?.priority_high_icon,
        hour_glass_icon: dataInfoCms?.hour_glass_icon,
        upload_icon: dataInfoCms?.upload_icon,
        eye_icon: dataInfoCms?.eye_icon,
        file_icon: dataInfoCms?.file_icon,
        delete_icon: dataInfoCms?.delete_icon,
      },
    },
  };
});

export const getClaimDetailsCmsData = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataInfoCms = cms.documents['desktop_claim_details_costumer_v2']?.data;

  return {
    components_items: dataInfoCms?.component_items,
    claim_recap_items: {
      recap_cards: dataInfoCms?.claim_recap_items,
      complete_claim_button: dataInfoCms?.complete_claim_button,
      geolocation_check_button: dataInfoCms?.geolocation_check_button,
      download_bp_button: dataInfoCms?.download_bp_button,
      redirect_events_button: dataInfoCms?.redirect_events_button,
      description_item: {
        description_icon: dataInfoCms?.description_icon,
        description_label: dataInfoCms?.description_label,
        description_show_less_label: dataInfoCms?.description_show_less_label,
        description_show_more_label: dataInfoCms?.description_show_more_label,
      },
      modal_generate_bp_error: dataInfoCms?.modal_generate_bp_error,
      modal_geolocation_check_info: dataInfoCms?.modal_geolocation_check_info,
      modal_degeolocalisation_error_confirm_button: dataInfoCms?.modal_degeolocalisation_error_confirm_button,
      modal_degeolocalisation_error_contact_button: dataInfoCms?.modal_degeolocalisation_error_contact_button,
      max_attempts_reached_message: dataInfoCms?.max_attempts_reached_message,
      attempts_messages: dataInfoCms?.attempts_messages,
      unknown_attempt_message: dataInfoCms?.unknown_attempt_message,
      error_attempt_message: dataInfoCms?.error_attempt_message,
    },
    claim_tips: dataInfoCms?.claim_tips,
    claim_trips_bg_comp: dataInfoCms?.tips_bg_image_comp?.url,
    claim_event_items: {
      wait_icon: dataInfoCms?.current_event_icon?.url,
      finish_icon: dataInfoCms?.event_finish_icon?.url,
      rejected_claim_label: dataInfoCms?.rejected_claim_label,
      motif_label: dataInfoCms?.motif_label,
      print_my_travel_voucher: dataInfoCms?.print_my_travel_voucher,
    },
    email_icon: dataInfoCms?.email_icon,
    phone_icon: dataInfoCms?.phone_icon,
    claim_document_items: {
      docuemtns_status_list: dataInfoCms?.docuemtns_status_list,
      document_number: dataInfoCms?.document_number,
      download_certificate_icon: dataInfoCms?.download_certificate_icon,
      download_certificate_text: dataInfoCms?.download_certificate_text,
      clean_documents: dataInfoCms?.clean_documents,
      documents_formats_upload_informations: dataInfoCms?.documents_formats_upload_informations,
      documents_size_upload_informations: dataInfoCms?.documents_size_upload_informations,
      documents_upload_informations: dataInfoCms?.documents_upload_informations,
      send_label: dataInfoCms?.send_label,
      send_document_text: dataInfoCms?.send_document_text,
      not_conforme_info_label: dataInfoCms?.not_conforme_info_label,
      modal_error: {
        modal_error_documents_formats: dataInfoCms?.modal_error_documents_formats,
        modal_error_documents_size: dataInfoCms?.modal_error_documents_size,
        modal_error_max_uploaded_documents: dataInfoCms?.modal_error_max_uploaded_documents,
      },
      claim_document_items_icon: {
        calander_icon: dataInfoCms?.calander_icon,
        done_icon: dataInfoCms?.done_icon,
        priority_high_icon: dataInfoCms?.priority_high_icon,
        hour_glass_icon: dataInfoCms?.hour_glass_icon,
        upload_icon: dataInfoCms?.upload_icon,
        eye_icon: dataInfoCms?.eye_icon,
        file_icon: dataInfoCms?.file_icon,
        delete_icon: dataInfoCms?.delete_icon,
      },
    },

    selling_point: {
      selling_point_icon: dataInfoCms?.selling_point_icon,
      selling_point_label: dataInfoCms?.selling_point_label,
    },
    contact_tab: {
      contact_block_text: dataInfoCms?.contact_block_text,
      contact_block_parag: dataInfoCms?.contact_block_parag,

      contact_choice: {
        contact_question: {
          contact_question_1: dataInfoCms?.contact_question_1,
          contact_question_2: dataInfoCms?.contact_question_2,
        },
        form_choice: dataInfoCms?.contact_choice.find(x => x.key === 'form_choice'),
        phone_choice: dataInfoCms?.contact_choice.find(x => x.key === 'phone_choice'),
        phone_choice_message: dataInfoCms?.phone_choice_message,
        phone_choice_label: dataInfoCms?.phone_choice_label,
        join_file_label: dataInfoCms?.join_file_label,
        upload: {
          upload_information_formats: dataInfoCms?.size_format_label,
          upload_information_taille: dataInfoCms?.size_max_document,
          upload_icon: dataInfoCms?.upload_icon?.url,
          file: {
            file_icon: dataInfoCms?.file.find(x => x.key === 'file_icon')?.file_icon?.url,
            delete_icon: dataInfoCms?.file.find(x => x.key === 'delete_icon')?.file_icon?.url,
            eye_icon: dataInfoCms?.file.find(x => x.key === 'eye_icon')?.file_icon?.url,
          },
          modal_succes_message: dataInfoCms?.modal_succes_message,
          modal_erreur_max_input_character: dataInfoCms?.modal_erreur_max_input_character,
          modal_erreur_max_upload_documents_label: dataInfoCms?.modal_erreur_max_upload_documents_label,
          modal_erreur_max_upload_documents_label_btn: dataInfoCms?.modal_erreur_max_upload_documents_label_btn,
          modal_ereur_document_formats: dataInfoCms?.modal_ereur_document_formats,
        },
        modal_messages: {
          modal_succes_message: dataInfoCms?.modal_succes_message,
          modal_erreur_max_input_character: dataInfoCms?.modal_erreur_max_input_character,
          modal_erreur_max_upload_documents_label: dataInfoCms?.modal_erreur_max_upload_documents_label,
          modal_erreur_max_upload_documents_label_btn: dataInfoCms?.modal_erreur_max_upload_documents_label_btn,
          modal_ereur_document_formats: dataInfoCms?.modal_ereur_document_formats,
          modal_erreur_document_file_size: dataInfoCms?.size_max_document || dataInfoCms?.modal_erreur_document_file_size,
        },
        textarea_label: dataInfoCms?.textarea_label,
        upload_button_label: dataInfoCms?.btn_send_label,
      },
    },
  };
});

export const getContactCustomerSelector = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataInfoCms = cms.documents['desktop_contact_customer']?.data;

  return {
    page_title: dataInfoCms?.contact_page_title,
    contact_question: {
      contact_question_1: dataInfoCms?.contact_question_1,
      contact_question_2: dataInfoCms?.contact_question_2,
    },
    select: {
      select_label: dataInfoCms?.select_label,
      subscription_number_label: dataInfoCms?.subscription_number_label,
      claim_number_label: dataInfoCms?.claim_number_label,
    },
    textArea: {
      textarea_placeholder_label: dataInfoCms?.textarea_placeholder_label,
      textarea_error_message: dataInfoCms?.textarea_error_message,
    },
    upload: {
      upload_icon: dataInfoCms?.upload_icon?.url,
      label_icon: dataInfoCms?.label_icon,
      upload_information_formats: dataInfoCms?.upload_information_formats,
      upload_information_taille: dataInfoCms?.upload_information_taille,
      file: {
        file_icon: dataInfoCms?.file_icon?.url,
        eye_icon: dataInfoCms?.eye_icon?.url,
        delete_icon: dataInfoCms?.delete_icon?.url,
      },
    },
    modal_messages: {
      modal_ereur_document_formats: dataInfoCms?.modal_ereur_document_formats,
      modal_erreur_document_file_size: dataInfoCms?.size_max_document || dataInfoCms?.modal_erreur_document_file_size,
      modal_erreur_max_upload_documents_label: dataInfoCms?.modal_erreur_max_upload_documents_label,
      modal_erreur_max_upload_documents_label_btn: dataInfoCms?.modal_erreur_max_upload_documents_label_btn,
      modal_erreur_max_input_character: dataInfoCms?.modal_erreur_max_input_character,
      modal_succes_message: dataInfoCms?.modal_succes_message,
    },
    upload_button_label: dataInfoCms?.upload_button_label,
  };
});

export const getContractCustomerSelector = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataInfoCms = cms.documents['desktop_contract_pdv_v2']?.data || cms.documents['desktop_contract_customer_v2']?.data;
  return {
    page_title: dataInfoCms?.page_title,
    search_text: dataInfoCms?.search_text,
    under_input_label: dataInfoCms?.under_input_labelt,
    search_label: dataInfoCms?.search_label,
    search_button: {
      search_button_icon: dataInfoCms?.search_button_icon,
      search_button_label: dataInfoCms?.search_button_label,
    },
    subscription: {
      insured_element_icon: dataInfoCms?.insured_element_icon?.url || dataInfoCms?.items_information?.find(x => x.key === ''),
      client_full_name: dataInfoCms?.items_information?.find(x => x.key === 'SHOW_CLIENT_FULLNAME'),
      selling_point: dataInfoCms?.items_information?.find(x => x.key === 'SHOW_SELLING_POINT'),
      client_claim_number: dataInfoCms?.items_information?.find(x => x.key === 'SHOW_CLIENT_CLAIM_NUMBER'),
      client_birthday: dataInfoCms?.items_information?.find(x => x.key === 'SHOW_CLIENT_BIRTHDAY'),
      subscription_label: dataInfoCms?.subscription_label,
      subscription_date_label:
        dataInfoCms?.subscription_date_label || dataInfoCms?.items_information?.find(x => x.key === 'SHOW_SUBSCRIPTION_DATE'),
      infos_bank_items: {},
      buttons: {
        consult_subscription: dataInfoCms?.consult_subscription,
        declare_claim: dataInfoCms?.declare_claim,
        consult_claims: dataInfoCms?.consult_claims,
      },
    },
    subscriber: {
      birthdate_label: dataInfoCms?.birthdate_label,
      birthplace_label: dataInfoCms?.birthplace_label,
      birth_icon: dataInfoCms?.birth_icon,
    },
    reset_search_text: dataInfoCms?.reset_search_text,
    search_result: dataInfoCms?.search_result,
    selling_point_placeholder: dataInfoCms?.selling_point_placeholder,
    susbcription_field_placeholder: dataInfoCms?.susbcription_field_placeholder,
    emty_search_value_message: dataInfoCms?.emty__search_value_message,
    first_search_message: dataInfoCms?.first__search_message,
    empty_search_message: dataInfoCms?.empty_search_message,
    check_declar_claim_message: dataInfoCms?.check_declar_claim_message,
    check_store_message: dataInfoCms?.check_store_message,
    check_length_name_search: dataInfoCms?.check_length_name_search,
    eye_icon: dataInfoCms?.eye_icon,
    search_subscription: {
      avatarText: dataInfoCms?.avatar_text,
      searchButton: dataInfoCms?.search_button,
      searchLink: dataInfoCms?.search_link,
      searchActionLink: dataInfoCms?.search_action_link,
    },
  };
});

export const getContactEngineSelector = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataInfoCms = cms.documents['mobile_contact_engine']?.data || cms.documents['mobile_contact_engine_v2']?.data;

  return {
    page_title: dataInfoCms?.contact_page_title,
    contact_first_text_in_top: dataInfoCms?.contact_first_text_in_top,
    contact_seconde_text_in_top: dataInfoCms?.contact_seconde_text_in_top,
    contact_text_in_bottom: dataInfoCms?.contact_text_in_bottom,
    contact_items: {
      FORM_CONTACT_MOBILE: dataInfoCms?.contact_items?.find(x => x.key === 'CHOOSE_FORM_CONTACT_MODE'),
      CHOOSE_TELEPHONE_CONTACT_MODE: dataInfoCms?.contact_items?.find(x => x.key === 'CHOOSE_TELEPHONE_CONTACT_MODE'),
      CHOOSE_CHAT_CONTACT_MODE_MOBILE: dataInfoCms?.contact_items?.find(x => x.key === 'CHOOSE_CHAT_CONTACT_MODE_MOBILE'),
      CHOOSE_WEBSITE_CONTACT_MODE_MOBILE: dataInfoCms?.contact_items?.find(x => x.key === 'CHOOSE_WEBSITE_CONTACT_MODE_MOBILE'),
      REDIRECT_CLAIMS: dataInfoCms?.contact_items?.find(x => x.key === 'REDIRECT_CLAIMS'),
      REDIRECT_CONTRACT: dataInfoCms?.contact_items?.find(x => x.key === 'REDIRECT_CONTRACT'),
    },
    contact_question: {
      contact_question_1: dataInfoCms?.contact_question_1,
      contact_question_2: dataInfoCms?.contact_question_2,
    },
    select: {
      select_label: dataInfoCms?.select_label,
      subscription_number_label: dataInfoCms?.subscription_number_label,
      claim_number_label: dataInfoCms?.claim_number_label,
    },
    textArea: {
      textarea_placeholder_label: dataInfoCms?.textarea_placeholder_label,
      textarea_error_message: dataInfoCms?.textarea_error_message,
    },
    upload: {
      upload_icon: dataInfoCms?.upload_icon?.url,
      label_icon: dataInfoCms?.label_icon,
      upload_information_formats: dataInfoCms?.upload_information_formats,
      upload_information_taille: dataInfoCms?.upload_information_taille,
      file: {
        file_icon: dataInfoCms?.file_icon?.url,
        eye_icon: dataInfoCms?.eye_icon?.url,
        delete_icon: dataInfoCms?.delete_icon?.url,
      },
    },
    modal_messages: {
      modal_ereur_document_formats: dataInfoCms?.modal_ereur_document_formats,
      modal_erreur_document_file_size: dataInfoCms?.size_max_document || dataInfoCms?.modal_erreur_document_file_size,
      modal_erreur_max_upload_documents_label: dataInfoCms?.modal_erreur_max_upload_documents_label,
      modal_erreur_max_upload_documents_label_btn: dataInfoCms?.modal_erreur_max_upload_documents_label_btn,
      modal_erreur_max_input_character: dataInfoCms?.modal_erreur_max_input_character,
      modal_succes_message: dataInfoCms?.modal_succes_message,
    },
    upload_button_label: dataInfoCms?.upload_button_label,
    mobile_contact_items: {
      mobile_contact_text: dataInfoCms?.mobile_contact_text,
      phone_contact_number: dataInfoCms?.phone_contact_number,
      phone_icon: dataInfoCms?.phone_icon,
    },
  };
});

export const getContractStatusCms = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataInfoCms =
    cms.documents['desktop_contract_and_claim_status']?.data || cms.documents['desktop_contract_and_claim_status_v2']?.data;

  return {
    contract_status_items: dataInfoCms?.contract_status_items,
  };
});
export const getAccoutAssignementSelector = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataInfoCms = cms.documents['mobile_account_assignement_v2']?.data;

  return {
    main_avatar_text: dataInfoCms?.main_avatar_text,
    text_info: dataInfoCms?.text_info,
    input_search_placeholder: dataInfoCms?.input_search_placeholder,
    btn_search_label: dataInfoCms?.btn_search_label,
    input_search_icone: dataInfoCms?.input_search_icone?.url,
    tooltip_icon: dataInfoCms?.tooltip_icon,
    tooltip_text: dataInfoCms?.tooltip_text,

    search_contract: {
      avatar_text: dataInfoCms?.avatar_text,
      subscription_label: dataInfoCms?.subscription_label,
      text_info: dataInfoCms?.text_info,
      date_label: dataInfoCms?.date_label,
      phone_label: dataInfoCms?.phone_label,
      error_text: dataInfoCms?.error_text,
      email_input_label: dataInfoCms?.email_input_label,
      email_input_placeholder: dataInfoCms?.email_input_placeholder,
      btn_valid_label: dataInfoCms?.btn_valid_label,
      btn_next_label: dataInfoCms?.btn_next_label,
      phone_bounded_label: dataInfoCms?.phone_bounded_label,
      smartphone_icone: dataInfoCms?.smartphone_icone?.url,
      search_modal_error: dataInfoCms?.search_modal_error,
      checkbox_label: dataInfoCms?.checkbox_label,
      email_alert: dataInfoCms?.email_alert,
      email_error_alert: dataInfoCms?.email_error_alert,
      no_correspondance_subscription: dataInfoCms?.no_correspondance_subscription,
      modal_info_perso_error: dataInfoCms?.modal_info_perso_error,
      required_input: dataInfoCms?.required_input,
      required_input_or_format: dataInfoCms?.required_input_or_format,
      textArea_placeholder: dataInfoCms?.textArea_placeholder,
      search_contact_us_label: dataInfoCms?.search_contact_us_label,
      search_contact_us_link_label: dataInfoCms?.search_contact_us_link_label,
    },
    administrator_contact: {
      icon_error_circle: dataInfoCms?.icon_error_circle?.url,
      eye_icon: dataInfoCms?.eye_icon?.url,
      delete_icon: dataInfoCms?.delete_icon?.url,
      phone_contact: dataInfoCms?.phone_contact,
      email_contact_label: dataInfoCms?.email_contact_label,
      email_contact_text: dataInfoCms?.email_contact_text,
      btn_back_label: dataInfoCms?.btn_back_label,
      firstname_lastname_label: dataInfoCms?.firstname_lastname_label,
      insert_subscription_text: dataInfoCms?.insert_subscription_text,
      contact_info_text: dataInfoCms?.contact_info_text,
      phone_icon: dataInfoCms?.phone_icon?.url,
      mail_icon: dataInfoCms?.mail_icon?.url,
      not_matched_sub_contact_avatar_text: dataInfoCms?.not_matched_sub_contact_avatar_text,
    },
    subscription_verification: {
      verification_avatar_text: dataInfoCms?.verification_avatar_text,
      security_text: dataInfoCms?.security_text,
      btn_sms_label: dataInfoCms?.btn_sms_label,
      btn_email_label: dataInfoCms?.btn_email_label,
      btn_send_label: dataInfoCms?.btn_send_label,
      btn_other_option: dataInfoCms?.btn_other_option,
      bnt_imei_validation_label: dataInfoCms?.bnt_imei_validation_label,
      bnt_iban_validation_label: dataInfoCms?.bnt_iban_validation_label,
      btn_no_other_option_label: dataInfoCms?.btn_no_other_option_label,
      btn_previous_option_label: dataInfoCms?.btn_previous_option_label,
      required_imei_msg: dataInfoCms?.required_imei_msg,
      btn_verif_label: dataInfoCms?.btn_verif_label,
      required_iban_msg: dataInfoCms?.required_iban_msg,
      verified_subscription_text: dataInfoCms?.verified_subscription_text,
      IMEI_placeholder: dataInfoCms?.IMEI_placeholder,
      zip_code_placeholder: dataInfoCms?.zip_code_placeholder,
      another_try_label: dataInfoCms?.another_try_label,
      verif_error: dataInfoCms?.verif_error,
      cancel_icon: dataInfoCms?.cancel_icon?.url,
      ArrowBackIcon: dataInfoCms?.arrowbackicon?.url,
      other_verif_options: dataInfoCms?.other_verif_options,
      resend_label: dataInfoCms?.resend_label,
      valider_label: dataInfoCms?.valider_label,
      my_subscription_label: dataInfoCms?.my_subscription_label,
      sent_code_email: dataInfoCms?.sent_code_email,
      sent_code_sms_phone: dataInfoCms?.sent_code_sms_phone,
      compliant_code_text: dataInfoCms?.compliant_code_text,
      code_sent_text: dataInfoCms?.code_sent_text,
      non_compliant_code_text: dataInfoCms?.non_compliant_code_text,
      expired_code_text: dataInfoCms?.expired_code_text,
      verif_inputs: {
        imei: dataInfoCms?.verif_inputs?.find(x => x.key === 'imei'),
        firstName: dataInfoCms?.verif_inputs?.find(x => x.key === 'firstName'),
        lastName: dataInfoCms?.verif_inputs?.find(x => x.key === 'lastName'),
        codePostal: dataInfoCms?.verif_inputs?.find(x => x.key === 'codePostal'),
        IBAN: dataInfoCms?.verif_inputs?.find(x => x.key === 'IBAN'),
      },
      subscription_verif_btn_next_label: dataInfoCms?.subscription_verif_btn_next_label,
      authentification_error_icon: dataInfoCms?.authentification_error_icon?.url,
      authentification_error_text: dataInfoCms?.authentification_error_text,
      authentification_error_text_iban: dataInfoCms?.authentification_error_text_iban,
      code_sended_success_icon: dataInfoCms?.code_sended_success_icon?.url,
      subscription_valide_text: dataInfoCms?.subscription_valide_text,
      subscription_valide_icon: dataInfoCms?.subscription_valide_icon?.url,
    },
    no_mattched_subscription: {
      not_matched_sub_avatar_text: dataInfoCms?.not_matched_sub_avatar_text,
      phone_text: dataInfoCms?.phone_text,
      email_text: dataInfoCms?.email_text,

      last_name_label: dataInfoCms?.last_name_label,
      first_name_label: dataInfoCms?.first_name_label,
      phone_number_label: dataInfoCms?.phone_number_label,
      email_label: dataInfoCms?.email_label,

      last_name_placeHolder: dataInfoCms?.last_name_placeholder,
      first_name_placeHolder: dataInfoCms?.first_name_placeholder,
      phone_number_placeHolder: dataInfoCms?.phone_placeholder,
      email_placeHolder: dataInfoCms?.email_placeholder,

      subscription_text_label: dataInfoCms?.subscription_text_label,
      format_document_text: dataInfoCms?.format_document_text,
      document_text: dataInfoCms?.document_text,
      join_file_label: dataInfoCms?.join_file_label,
      btn_send_label: dataInfoCms?.btn_send_label,
      join_file_icone: dataInfoCms?.join_file_icone,
      delete_icon: dataInfoCms?.delete_icon1,
      eye_icon: dataInfoCms?.eye_icon1,
      file_size_error: dataInfoCms?.file_size_error,
      file_format_error: dataInfoCms?.file_format_error,
      file_size_list_error: dataInfoCms?.file_size_list_error,
      message_lower_size_error: dataInfoCms?.message_lower_size_error,
    },
    assaignement_contract: {
      correct_info: dataInfoCms?.correct_info,
      subscription_match_error: dataInfoCms?.subscription_match_error,
      subscription_match_avatar_text: dataInfoCms?.subscription_match_avatar_text,
      another_subscription_msg: dataInfoCms?.another_subscription_msg,
      btn_next_label: dataInfoCms?.btn_next_label,
      wrong_informations_select: dataInfoCms?.wrong_informations_select,
      correct_informations_select: dataInfoCms?.correct_informations_select,
      btn_send_label: dataInfoCms?.btn_send_label,
    },
  };
});
export const getSigninSelector = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataInfoCms = cms.documents['mobile_signin_page']?.data;

  return {
    avatar_text: dataInfoCms?.avatar_text,
    components_item: dataInfoCms?.component_items[0],
  };
});
export const contractDocumentsDataSelector = (docName: string) =>
  createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
    const contractDocumentsData = cms.documents[docName]?.data || null;
    return contractDocumentsData;
  });

export const getDesktopContractSelector = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataDesktopContractCms =
    cms.documents['desktop_contract_det']?.data ||
    cms.documents['desktop_contract_details_pdv']?.data ||
    cms.documents['desktop_contract_det_v2']?.data;

  return {
    component_recap_items: dataDesktopContractCms?.component_recap_items,

    component_recap_contractual: {
      contractual_title: dataDesktopContractCms?.contractual_title,
      contractual_icon: dataDesktopContractCms?.contractual_icon,
      contractual_color: dataDesktopContractCms?.contractual_color,
    },
    rescind_contract: {
      rescind_choice_title: dataDesktopContractCms?.rescind_choice_title,
      rescind_choice_item: dataDesktopContractCms?.rescind_choice_item,
      rescind_phone_choice_title: dataDesktopContractCms?.mobile_choice_tab_title,
      rescind_phone_choice_text: dataDesktopContractCms?.mobile_choice_tab_text,
      rescind_phone_choice_icon: dataDesktopContractCms?.mobile_choice_tab_icon,
      rescind_phone_choice_previous_button: dataDesktopContractCms?.mobile_choice_previous_button,
      rescind_contact_choice_title: dataDesktopContractCms?.contact_choice_tab_title,
      rescind_contact_choice_text: dataDesktopContractCms?.contact_choice_tab_text,
      rescind_contact_choice_icon: dataDesktopContractCms?.contact_choice_tab_icon,
      rescind_contact_choice_previous_button: dataDesktopContractCms?.contact_choice_previous_button,
      rescind_motif_tab_title: dataDesktopContractCms?.rescind_motif_tab_title,
      rescind_motif_next_button: dataDesktopContractCms?.rescind_motif_next_button,
      rescind_motif_previous_button: dataDesktopContractCms?.rescind_motif_previous_button,
      rescind_motif_tab_item: dataDesktopContractCms?.rescind_motif_tab_item,
    },
    bank_info_tab: {
      titulaire_compte_label: dataDesktopContractCms?.titulaire_compte_label,
      iban_label: dataDesktopContractCms?.iban_label,
      bic_label: dataDesktopContractCms?.bic_label,
      btn_annuler_label: dataDesktopContractCms?.btn_annuler_label,
      btn_confirmer_label: dataDesktopContractCms?.btn_confirmer_label,
      bank_icon: dataDesktopContractCms?.bank_icon?.url,
      edit_button: dataDesktopContractCms?.edit_button?.url,
      update_titulaire_compte_label: dataDesktopContractCms?.update_titulaire_compte_label,
      titulaire_compte_placeHolder: dataDesktopContractCms?.titulaire_compte_placeholder,
      iban_placeHolder: dataDesktopContractCms?.iban_placeholder,
      bic_placeHolder: dataDesktopContractCms?.bic_placeholder,
      info_bank_modal_error: dataDesktopContractCms?.info_bank_modal_error,
      iban_error_msg: dataDesktopContractCms?.iban_error_msg,
      required_titulaire_msg: dataDesktopContractCms?.required_titulaire_msg,
      required_iban_msg: dataDesktopContractCms?.required_iban_msg,
    },
    cotisation_tab: {
      cotisation_quantity_text_singular: dataDesktopContractCms?.cotisation_quantity_text_singular,
      cotisation_quantity_text_plural: dataDesktopContractCms?.cotisation_quantity_text_plural,
      cotisation_amount_icon: dataDesktopContractCms?.cotisation_amount_icon?.url,
      cotisation_amount: dataDesktopContractCms?.cotisation_amount,
      cotisation_date_icon: dataDesktopContractCms?.cotisation_date_icon?.url,
      cotisation_date: dataDesktopContractCms?.cotisation_date,
      cotisation_warning: dataDesktopContractCms?.cotisation_warning,
      cotisation_warning_plural: dataDesktopContractCms?.cotisation_warning_plural,
      cotisation_success_icon: dataDesktopContractCms?.cotisation_success_icon?.url,
      cotisation_success: dataDesktopContractCms?.cotisation_success,
      cotisation_resubmitted_singular: dataDesktopContractCms?.cotisation_resubmitted_singular,
      cotisation_resubmitted_plural: dataDesktopContractCms?.cotisation_resubmitted_plural,
      cotisation_updated: dataDesktopContractCms?.cotisation_updated,
      cotisation_to_pay_label: dataDesktopContractCms?.cotisation_to_pay_label,
      cotisation_total_label: dataDesktopContractCms?.cotisation_total_label,
      cotisation_taxes_label: dataDesktopContractCms?.cotisation_taxes_label,
      cotisation_payement_success: dataDesktopContractCms?.cotisation_payement_success,
      status_paybox: dataDesktopContractCms?.status_paybox,
    },
    birth_date_label_mme: dataDesktopContractCms?.birth_date_label_mme,
    birth_date_label_mr: dataDesktopContractCms?.birth_date_label_mr,
    btn_declare_claim_label: dataDesktopContractCms?.btn_declare_claim_label,
    check_declar_claim_message: dataDesktopContractCms?.check_declar_claim_message,
    btn_follow_claims_label: dataDesktopContractCms?.btn_follow_claims_label,
    btn_follow_claim_label: dataDesktopContractCms?.btn_follow_claim_label,
    contract_engine_header: dataDesktopContractCms?.component_items || dataDesktopContractCms?.contract_engine_header,
    component_items_infos_perso: dataDesktopContractCms?.component_items_infos_perso,
    contract_status: dataDesktopContractCms?.contract_status,
    status: dataDesktopContractCms?.status,
    status_contract_label: dataDesktopContractCms?.status_contract_label,
    staus_contract_label: dataDesktopContractCms?.staus_contract_label,
    infos_bank_items: dataDesktopContractCms?.infos_bank_items,
    birth_date_icone: dataDesktopContractCms?.birthdate_icone?.url,
    city_icone: dataDesktopContractCms?.city_icone?.url,
    user_icone: dataDesktopContractCms?.user_icone?.url,
    icone_sub_number: dataDesktopContractCms?.icone_sub_number?.url,
    btn_cancel_label: dataDesktopContractCms?.btn_cancel_label,
    btn_confirm_label: dataDesktopContractCms?.btn_confirm_label,
    bank_block_title: dataDesktopContractCms?.bank_block_title,
    link_cancel_insurance_label: dataDesktopContractCms?.link_cancel_insurance_label,
    bank_input_items: {
      bic: (dataDesktopContractCms?.bank_input_items || [])?.find(x => x.key === 'BIC'),
      iban: (dataDesktopContractCms?.bank_input_items || [])?.find(x => x.key === 'IBAN'),
    },

    contact_tab: {
      contact_block_text: dataDesktopContractCms?.contact_block_text,
      contact_block_parag: dataDesktopContractCms?.contact_block_parag,

      contact_choice: {
        contact_question: {
          contact_question_1: dataDesktopContractCms?.contact_question_1,
          contact_question_2: dataDesktopContractCms?.contact_question_2,
        },
        form_choice: (dataDesktopContractCms?.contact_choice || [])?.find(x => x.key === 'form_choice'),
        phone_choice: (dataDesktopContractCms?.contact_choice || [])?.find(x => x.key === 'phone_choice'),
        phone_choice_message: dataDesktopContractCms?.phone_choice_message,
        phone_choice_label: dataDesktopContractCms?.phone_choice_label,
        join_file_label: dataDesktopContractCms?.join_file_label,
        upload: {
          upload_information_formats: dataDesktopContractCms?.size_format_label,
          upload_information_taille: dataDesktopContractCms?.size_max_document,
          upload_icon: dataDesktopContractCms?.upload_icon?.url,
          file: {
            file_icon: (dataDesktopContractCms?.file || [])?.find(x => x.key === 'file_icon')?.file_icon?.url,
            delete_icon: (dataDesktopContractCms?.file || [])?.find(x => x.key === 'delete_icon')?.file_icon?.url,
            eye_icon: (dataDesktopContractCms?.file || [])?.find(x => x.key === 'eye_icon')?.file_icon?.url,
          },
        },
        modal_messages: {
          modal_succes_message: dataDesktopContractCms?.modal_succes_message,
          modal_erreur_max_input_character: dataDesktopContractCms?.modal_erreur_max_input_character,
          modal_erreur_max_upload_documents_label: dataDesktopContractCms?.modal_erreur_max_upload_documents_label,
          modal_erreur_max_upload_documents_label_btn: dataDesktopContractCms?.modal_erreur_max_upload_documents_label_btn,
          modal_ereur_document_formats: dataDesktopContractCms?.modal_ereur_document_formats,
          modal_erreur_document_file_size:
            dataDesktopContractCms?.size_max_document || dataDesktopContractCms?.modal_erreur_document_file_size,
        },
        textarea_label: dataDesktopContractCms?.textarea_label,
        upload_button_label: dataDesktopContractCms?.btn_send_label,
      },
    },
    input_list: {
      street: dataDesktopContractCms?.input_list?.find(x => x.key === 'street'),
      streetNumber: dataDesktopContractCms?.input_list?.find(x => x.key === 'streetNumber'),
      additionalAddress: dataDesktopContractCms?.input_list?.find(x => x.key === 'additionalAddress'),
      city: dataDesktopContractCms?.input_list?.find(x => x.key === 'city'),
      codePostal: dataDesktopContractCms?.input_list?.find(x => x.key === 'codePostal'),
      email: dataDesktopContractCms?.input_list?.find(x => x.key === 'email'),
      phone: dataDesktopContractCms?.input_list?.find(x => x.key === 'phone'),
    },
    modal_error_msg: dataDesktopContractCms?.modal_error_msg,
    modal_succses_msg: dataDesktopContractCms?.modal_succses_msg,
  };
});

export const getDesktopClaimFreeSelector = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataDesktopclaimsFreeCms =
    cms.documents['desktop_claim_customer']?.data ||
    cms.documents['desktop_claim_pdv_v2']?.data ||
    cms.documents['desktop_claim_customer_v2']?.data;

  return {
    page_title: dataDesktopclaimsFreeCms?.page_title,
    search_text: dataDesktopclaimsFreeCms?.search_text,
    claim_items: dataDesktopclaimsFreeCms?.claim_items,
    page_title_singular: dataDesktopclaimsFreeCms?.page_title_singular,
    search_label: dataDesktopclaimsFreeCms?.search_label,
    reset_search_text: dataDesktopclaimsFreeCms?.reset_search_text,
    search_button: {
      search_button_icon: dataDesktopclaimsFreeCms?.search_button_icon,
      search_button_label: dataDesktopclaimsFreeCms?.search_button_label,
    },
    selling_point_placeholder: dataDesktopclaimsFreeCms?.selling_point_placeholder,
    search_result: dataDesktopclaimsFreeCms?.search_result,
    susbcription_field_placeholder: dataDesktopclaimsFreeCms?.susbcription_field_placeholder,
    DECLARATION_DATE: dataDesktopclaimsFreeCms?.information_list?.find(x => x.key === 'DECLARATION_DATE'),
    COVER_CLAIM: dataDesktopclaimsFreeCms?.information_list?.find(x => x.key === 'COVER_CLAIM'),
    eye_icon: dataDesktopclaimsFreeCms?.eye_icon,
    claim_lable: dataDesktopclaimsFreeCms?.claim_lable,
    check_store_message: dataDesktopclaimsFreeCms?.check_store_message,
    check_length_name_search: dataDesktopclaimsFreeCms?.check_length_name_search,
    empty_search_message: dataDesktopclaimsFreeCms?.empty_search_message,
    check_declar_claim_message: dataDesktopclaimsFreeCms?.check_declar_claim_message,
    first_search_message: dataDesktopclaimsFreeCms?.first_search_message,
    under_input_label: dataDesktopclaimsFreeCms?.under_input_label,
  };
});

export const getModalInformationButton = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataModalInformation = cms.documents['modal_informations']?.data;
  return {
    Success_Icon: dataModalInformation?.succes_icon,
    erreur_Icon: dataModalInformation?.erreur_icon,
    CONFIRMED_button: dataModalInformation?.buttons?.find(x => x?.key === 'CONFIRMED')?.label,
    UNDERSTAND_button: dataModalInformation?.buttons?.find(x => x?.key === 'UNDERSTAND')?.label,
    CLOSE_button: dataModalInformation?.buttons?.find(x => x?.key === 'CLOSE')?.label,
    CANCEL_button: dataModalInformation?.buttons?.find(x => x?.key === 'CANCEL')?.label,
    OK_button: dataModalInformation?.buttons?.find(x => x?.key === 'OK')?.label,
  };
});

export const getMobileClaimFreeSelector = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const dataMobileclaimsFreeCms = cms.documents['mobile_claim_customer']?.data || cms.documents['mobile_claim_customer_v2']?.data;
  return {
    claim_label: dataMobileclaimsFreeCms?.claim_lable,
    claims_label: dataMobileclaimsFreeCms?.claims_lables,
    claims_label_singular: dataMobileclaimsFreeCms?.claims_lables_singular,
    consulter_label: dataMobileclaimsFreeCms?.consulter_label,
    phone_icon: dataMobileclaimsFreeCms?.phone_icon?.url,
    eye_icon: dataMobileclaimsFreeCms?.eye_icon?.url,
    date_icon: dataMobileclaimsFreeCms?.information_list.find(x => x.key === 'DECLARATION_DATE')?.icon?.url,
    date_label: dataMobileclaimsFreeCms?.information_list.find(x => x.key === 'DECLARATION_DATE')?.label,
    cover_icon: dataMobileclaimsFreeCms?.information_list.find(x => x.key === 'COVER_CLAIM')?.icon?.url,
    cover_label: dataMobileclaimsFreeCms?.information_list.find(x => x.key === 'COVER_CLAIM')?.label,
  };
});

export const getAccountSelector = createSelector<IRootState, CmsState, any>(selectCmsState, (cms: CmsState) => {
  const accountdataCms = cms.documents['desktop_account']?.data;
  return {
    account_bank_info: {
      comp_title: accountdataCms?.comp_title,
      modal_success_message: accountdataCms?.modal_success_message,
      titulaire_compte_label: accountdataCms?.titulaire_compte_label,
      iban_label: accountdataCms?.iban_label,
      bic_label: accountdataCms?.bic_label,
      btn_annuler_label: accountdataCms?.btn_annuler_label,
      btn_confirmer_label: accountdataCms?.btn_confirmer_label,
      bank_icon: accountdataCms?.bank_icon?.url,
      edit_button: accountdataCms?.edit_button?.url,
      update_titulaire_compte_label: accountdataCms?.update_titulaire_compte_label,
      titulaire_compte_placeHolder: accountdataCms?.titulaire_compte_placeholder,
      iban_placeHolder: accountdataCms?.iban_placeholder,
      bic_placeHolder: accountdataCms?.bic_placeholder,
      info_bank_modal_error: accountdataCms?.info_bank_modal_error,
      iban_error_msg: accountdataCms?.iban_error_msg,
      required_titulaire_msg: accountdataCms?.required_titulaire_msg,
      required_iban_msg: accountdataCms?.required_iban_msg,
    },
  };
});
